import React from 'react';

const TimeSlotSkeleton = () => {
  return (
    <div className="w-full p-4 md:p-5 lg:p-6 rounded-xl bg-muted animate-pulse">
      <div className="flex flex-col items-center gap-2 md:gap-3">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 bg-muted-foreground/20 rounded"></div>
          <div className="w-16 h-6 md:h-7 lg:h-8 bg-muted-foreground/20 rounded"></div>
        </div>
        <div className="w-20 h-4 bg-muted-foreground/20 rounded"></div>
        <div className="w-16 h-3 bg-muted-foreground/20 rounded mt-1"></div>
      </div>
    </div>
  );
};

export default TimeSlotSkeleton;